module.exports = __webpack_public_path__ + "img/data-icon-3.63063c9a.png";